import React, { Component, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Icon,
  Input,
  Table,
  Button,
  Select,
  message,
  notification,
  Spin,
  Tooltip,
  Checkbox,
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import EditAgencyModal from "./edit-agency-modal";
import EditUserModal from "./edit-user-modal";
import Cookies from "js-cookie";
import { Translate } from "react-translated";
import { debounceQuery, removeHeaderTitle } from "../../utils/Constants";
import { ACTIVE_AGENCIES_API_URL } from "../../utils/Api_enums";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';
import { useBoundStore } from "../../store/useBoundStore";
import { clearSharedDashboardDateState } from "../../utils/clearSharedDashboardDateState";

const Option = Select.Option;

class ActiveAgencies extends Component {
  state = {
    gridApi: null,
    columnApi: null,
    loading: true,
    allAgencies: [],
    agencies: [],
    page: 1,
    total_pages: 0,
    agency: {},
    user: {},
    edit_agency_modal: false,
    search: "",
    search_address: "",
    current_agency_index: null,
    sortingAccendingDesending: 1, // true for accending false for descending
    hideTestAgencies: false,
  };
  componentDidMount = () => {
    this.loadAllAgencies();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.refreshInfo();
    }
  };

  loadAllAgencies = () => {
    this.loadAgencies(this.state.page, 1);
  };
  // loadAgencies = (page, isinitial) => {
  // const filters = [];

  loadAgencies = (page = 1) => {
    // filters.push({ name: "active", op: "==", val: 1 });

    // const searchPurify = F.removeSpecialCharactersFromString(
    //   this.state.search.trim()
    // );

    // if (searchPurify.trim().length >= 0) {
    //   filters.push({
    //     or: [
    //       {
    //         name: "name",
    //         op: "like",
    //         val: encodeURIComponent("%" + searchPurify + "%"),
    //       },
    //       {
    //         name: "primary",
    //         op: "has",
    //         val: {
    //           name: "first_name",
    //           op: "like",
    //           val: encodeURIComponent("%" + searchPurify + "%"),
    //         },
    //       },
    //       {
    //         name: "primary",
    //         op: "has",
    //         val: {
    //           name: "last_name",
    //           op: "like",
    //           val: encodeURIComponent("%" + searchPurify + "%"),
    //         },
    //       },
    //     ],
    //   });
    // }

    // if (onlyAbbrevation.trim() !== "" && isinitial !== 0) {
    //   filters.push({
    //     name: "address",
    //     op: "like",
    //     val: encodeURIComponent("%" + onlyAbbrevation + "%"),
    //   });
    // }

    // const api =
    //   "/api/admin_feed?page=" +
    //   page +
    //   '&q={"filters":' +
    //   JSON.stringify(filters) +
    //   "}";
    const { search_address, search, sortBy, sortOrder } = this.state;
    let api = `${ACTIVE_AGENCIES_API_URL}?page=${page}`;
    if (search_address) {
      const onlyAbbrevation = search_address.split("+")[0] || "";
      api += `&address=${onlyAbbrevation}`;
    }
    if (search.trim()) {
      api += `&search_word=${encodeURIComponent(search.trim())}`;
    }
    if (sortBy) {
      api += `&sort_by=${sortBy}`;
    }
    if (sortOrder) {
      api += `&sort_order=${sortOrder}`;
    }
    if (this.state.hideTestAgencies) {
      // api += `&test=0${this.state.hideTestAgencies ? 1 : 0}`;
      api += `&test=0`;
    }
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      this.props.setState({ total_agencies: res.data.total })
      this.setState({
        // agencies: res.data.objects,
        // page: res.data.page,
        // total_pages: res.data.total_pages,
        // ...(isinitial === 0 && { allAgencies: res.data.objects }),
        loading: false,
        agencies: res.data.agencies,
        page: res.data.current_page,
        total_pages: res.data.pages,
      });
    });
  };
  updateAgency = (name, value) => {
    const { agencies, current_agency_index } = this.state;
    agencies[current_agency_index][name] = value;
    this.setState({ agencies });
  };
  updateUser = (user) => {
    const { agencies, current_agency_index } = this.state;
    agencies[current_agency_index].primary = user;
    this.setState({ agencies });
  };
  switchUser = (user) => {
    localStorage.removeItem("agGridColumnState");
    notification.destroy()
    this.setState({ loading: true });
    removeHeaderTitle();
    axios
      .post("/api/switchuser/" + user.id)
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success) {
          const user = res.data.user;
          useBoundStore.getState().resetUserInfo();
          useBoundStore.getState().resetUserById();
          Cookies.set(
            "user_info",
            JSON.stringify({
              first_name: user.first_name,
              last_name: user.last_name,
              email: user.email,
              id: user.id,
              user_type: user.user_type,
              default_date: user.default_date,
              last_login: user.last_login,
              language: user.language,
              active: user.active
            }), {
            secure: true,           //  HTTPS only
            sameSite: 'Lax',        // Add this — fixes the scan finding
            path: '/',              // explicit path
          }
          );
          useBoundStore.getState().resetAgencyInfo();
          clearSharedDashboardDateState();
          localStorage.setItem('user_t', "");
          localStorage.setItem('sa_user_route','/super-admin');
          this.props.history.push("/dashboard");
          window.location.reload();
        } else {
          message.error(F.translate(`Can't switch to the user.`));
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error(F.translate(`Can't switch to the user.`));
      });
  };

  sort = () => {
    if (this.state.agencies.length) {
      let sortedAgencies = [];

      if (this.state.sortingData) {
        sortedAgencies = this.state.agencies.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
      } else {
        sortedAgencies = this.state.agencies.sort((a, b) =>
          a.name < b.name ? 1 : -1
        );
      }
      this.setState({
        agencies: sortedAgencies,
        sortingData: !this.state.sortingData, // NOSONAR
      });
    }
  };

  onSelectState = (value) => {
    if (!value) {
      this.setState({
        search_address: "",
        //  search: "" 
      }, () => {
        this.loadAgencies(1);
      });
    } else {
      this.setState({
        search_address: value,
        // search: ""
      }, () => {
        this.loadAgencies(1);
      });
    }
  };

  onSearchAgency = (event) => {
    this.setState(
      {
        search: event.target.value,
        // search_address: "",
      },
      () => debounceQuery(this.loadAgencies.bind(this, 1))
    );
  };

  refreshInfo = () => {
    localStorage.removeItem("agGridColumnState");

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }

    this.setState({ search: "", search_address: "", hideTestAgencies: false }, () => {
      this.loadAllAgencies();
    });
  };



  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  render() {
    const { loading, agencies, page, total_pages } = this.state;

    const states = [
      { name: "Alabama", value: "AL" },
      { name: "Alaska", value: "AK" },
      { name: "Arizona", value: "AZ" },
      { name: "Arkansas", value: "AR" },
      { name: "California", value: "CA" },
      { name: "Colorado", value: "CO" },
      { name: "Connecticut", value: "CT" },
      { name: "Delaware", value: "DE" },
      { name: "District Of Columbia", value: "DC" },
      { name: "Florida", value: "FL" },
      { name: "Georgia", value: "GA" },
      { name: "Hawaii", value: "HI" },
      { name: "Idaho", value: "ID" },
      { name: "Illinois", value: "IL" },
      { name: "Indiana", value: "IN" },
      { name: "Iowa", value: "IA" },
      { name: "Kansas", value: "KS" },
      { name: "Kentucky", value: "KY" },
      { name: "Louisiana", value: "LA" },
      { name: "Maine", value: "ME" },
      { name: "Maryland", value: "MD" },
      { name: "Massachusetts", value: "MA" },
      { name: "Michigan", value: "MI" },
      { name: "Minnesota", value: "MN" },
      { name: "Mississippi", value: "MS" },
      { name: "Missouri", value: "MO" },
      { name: "Montana", value: "MT" },
      { name: "Nebraska", value: "NE" },
      { name: "Nevada", value: "NV" },
      { name: "New Hampshire", value: "NH" },
      { name: "New Jersey", value: "NJ" },
      { name: "New Mexico", value: "NM" },
      { name: "New York", value: "NY" },
      { name: "North Carolina", value: "NC" },
      { name: "North Dakota", value: "ND" },
      { name: "Ohio", value: "OH" },
      { name: "Oklahoma", value: "OK" },
      { name: "Oregon", value: "OR" },
      { name: "Pennsylvania", value: "PA" },
      { name: "Rhode Island", value: "RI" },
      { name: "South Carolina", value: "SC" },
      { name: "South Dakota", value: "SD" },
      { name: "Tennessee", value: "TN" },
      { name: "Texas", value: "TX" },
      { name: "Utah", value: "UT" },
      { name: "Vermont", value: "VT" },
      { name: "Virginia", value: "VA" },
      { name: "Washington", value: "WA" },
      { name: "West Virginia", value: "WV" },
      { name: "Wisconsin", value: "WI" },
      { name: "Wyoming", value: "WY" },
    ];

    // ag-Grid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: 'Agency',
        field: "name",
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Agency"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "name",
        }),
        cellRendererFramework: (params) => (
          <React.Fragment>
            <Link to={`/super-admin/agency/${params.data.id}`}>{params.data.name}</Link>
            {params.data.test === 1 && (
              <Tooltip
                placement="top"
                title={<Translate text={'Test Agency'} />}
                getPopupContainer={() => document.querySelector('.ag-theme-material')}
              >
                <span style={{ color: "red" }}> (TA)</span>
              </Tooltip>
            )}
          </React.Fragment>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'First Name',
        field: "first_name",
        minWidth: 150,
        sortable: false,
        flex: 1,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["First Name"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "first_name",
        }),
        valueGetter: params => (params.data.primary && params.data.primary.first_name) ? params.data.primary.first_name : '',
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Last Name',
        field: "last_name",
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Last Name"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "last_name",
        }),
        valueGetter: params => (params.data.primary && params.data.primary.last_name) ? params.data.primary.last_name : '',
      },
      {
        headerClass: 'custom-ag-header',
        headerName: '',
        field: 'actions',
        minWidth: 620,
        flex: 2,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Actions"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "actions",
        }),
        // sortable: false,
        cellRendererFramework: (params) => {
          const i = agencies.findIndex(a => a.id === params.data.id);
          return (
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 8, height: '100%' }}>
              <Button
                className="borderRadius-28"
                onClick={() => {
                  this.setState({
                    agency: params.data,
                    edit_agency_modal: true,
                    current_agency_index: i,
                  });
                }}
              >
                <Icon type="edit" /> Edit Agency
              </Button>
              <Button
                className="borderRadius-28"
                onClick={() => {
                  this.setState({
                    user: params.data.primary,
                    edit_user_modal: true,
                    current_agency_index: i,
                  });
                }}
                style={{ marginLeft: 10 }}
              >
                <Icon type="edit" /> Edit Agency Owner
              </Button>
              <Button
                className="borderRadius-28"
                onClick={() => this.switchUser(params.data.primary)}
                style={{ marginLeft: 10 }}
              >
                <Icon type="export" /> Switch to Agency Owner
              </Button>
            </div>
          );
        },
      },
    ];

    const data = [];
    for (let i = 0; i < agencies.length; i++) {
      let agency = agencies[i];

      data.push({
        key: i,
        agency: (
          <React.Fragment>
            <Link to={"/super-admin/agency/" + agency.id}>{agency.name}</Link>
            {agency.test === 1 && (<Tooltip
              placement="top"
              title={<Translate text={'Test Agency'} />}
            >
              <span style={{ color: "red" }}> (TA)</span>
            </Tooltip>)}
          </React.Fragment>
        ),
        ranking: agency.ranking !== "" ? agency.ranking : "-",
        first_name: agency.primary.first_name,
        last_name: agency.primary.last_name,
        action: (
          <div className="right-align">
            <Button
              className="borderRadius-28"
              onClick={() => {
                this.setState({
                  agency: agency,
                  edit_agency_modal: true,
                  current_agency_index: i,
                });
              }}
            >
              <Icon type="edit" /> Edit Agency
            </Button>
            <Button
              className="borderRadius-28"
              onClick={() => {
                this.setState({
                  user: agency.primary,
                  edit_user_modal: true,
                  current_agency_index: i,
                });
              }}
              style={{ marginLeft: 10 }}
            >
              <Icon type="edit" /> Edit Agency Owner
            </Button>
            <Button
              className="borderRadius-28"
              onClick={() => this.switchUser(agency.primary)}
              style={{ marginLeft: 10 }}
            >
              <Icon type="export" /> Switch to Agency Owner
            </Button>
          </div>
        ),
      });
    }

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              Active Agencies
              <span
                style={{ marginLeft: 10, cursor: "pointer", fontSize: "20px" }}
                onClick={() => this.sort()}
                role="button"
                tabIndex="0"
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.sort();
                  }
                }}
                aria-label="Sort items"
              >
                ↑
              </span>
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <div className="agency-filters">
              <Row gutter={16} justify="space-between" align="middle" >
                <Col flex="1 1 180px" className="agency-col">
                  <Input
                    placeholder="Search Agency"
                    className="borderRadius-28"
                    onChange={(e) => this.onSearchAgency(e)}
                    style={{ width: "200px" }}
                    value={this.state.search}
                    onPressEnter={() => {
                      const searchPurify = F.removeSpecialCharactersFromString(
                        this.state.search
                      );

                      if (searchPurify.trim().length > 0) {
                        if (searchPurify.trim().length >= 0) {
                          this.loadAgencies(1);
                        }
                      }
                    }}
                  />
                  {this.state.search ? (
                    <Icon
                      type="close"
                      onClick={() => this.onSearchAgency({ target: { value: "" } })}
                      className="icon-style"
                    />
                  ) : (
                    <Icon
                      type="search"
                      className="icon-style"
                    />
                  )}
                </Col>
                <Col flex="1 1 180px" className="agency-col">
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select State"
                    className='custom-select'
                    style={{
                      width: '200px',
                      fontSize: '13px',
                      backgroundColor: 'white',
                      borderRadius: '20px',
                      fontWeight: 500
                    }}
                    onChange={(value) => {
                      this.onSelectState(value);
                    }}
                    value={this.state.search_address || []}
                  >
                    {states.map((item, i) => (
                      <Option value={item.value + "+" + item.name} key={i} style={{ fontSize: '13px' }}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col className="agency-col">
                  <Checkbox
                    className="hide-test-agencies-checkbox"
                    onChange={(e) => {
                      const hideTestAgencies = e.target.checked;
                      this.setState({ hideTestAgencies }, () => {
                        this.loadAgencies(1);
                      })
                    }
                    }
                    checked={this.state.hideTestAgencies}
                  >
                    <Translate text="Hide Test Agencies" />
                  </Checkbox>
                </Col>
                <Col flex="none" className="agency-col">
                  {/* <div style={{ display: 'flex', justifyContent: 'flex-start' }}> */}
                  <Button
                    type="primary"
                    className="bg-164897"
                    style={{ borderRadius: 10 }}
                    onClick={this.refreshInfo}
                  >
                    <Icon type="reload" />
                    {/* Refresh */}
                  </Button>
                  {/* </div> */}
                </Col>
              </Row>
            </div>
          }
        >
          <Spin spinning={loading}>
            <CustomAgGridTable
              onGridReady={this.onGridReady}
              onColumnMoved={this.saveState}
              onSortChanged={this.saveState}
              onFilterChanged={this.saveState}
              rowDatas={agencies}
              columnDefss={columnDefs}
            />
          </Spin>
          <Pagination
            className="pagination-container cpagination"
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadAgencies(page);
            }}
          />
        </Card>
        <EditAgencyModal
          history={this.props.history}
          showModal={this.state.edit_agency_modal}
          hideModal={() => this.setState({ edit_agency_modal: false })}
          agency={this.state.agency}
          updateAgency={this.updateAgency.bind(this)}
          loadAllAgencies={this.loadAllAgencies.bind(this)}
        />
        <EditUserModal
          history={this.props.history}
          showModal={this.state.edit_user_modal}
          hideModal={() => this.setState({ edit_user_modal: false })}
          user={this.state.user}
          updateUser={this.updateUser.bind(this)}
        />
      </div>
    );
  }
}

export default ActiveAgencies;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/active-agencies.js